// @flow
import React, { type Node } from 'react';
import context from 'app/common/lib/context';
import GenericExperiment from 'app/packages/pinterest-experiments/Experiment';
import type { AuthViewer } from 'app/packages/pinterest-flow-types/viewer';
import withViewer from 'app/common/lib/react/withViewer';
import { isNewUser } from 'app/common/lib/ActivationUtil';
import { RequestContextConsumer } from 'app/common/react/components/RequestContext';

type HOCProps = {|
  viewer: AuthViewer,
|};

type Props = {|
  ...HOCProps,
  children: ({ anyEnabled: boolean }) => Node,
|};

const eligibleForBoostExp = (viewer: AuthViewer, language: string): boolean =>
  viewer.isPartner &&
  isNewUser({ user: viewer }) &&
  language === 'en' &&
  context.instance.site_type === PCONST.thrift.SiteType.DESKTOP;

export function BoostTextExperiment({ children, viewer }: Props): Node {
  return (
    <RequestContextConsumer>
      {(requestContext) => (
        <GenericExperiment
          activate
          activateExperiment={(expName: string): string =>
            requestContext.experiments.v2ActivateExperiment(expName) || ''
          }
          group={requestContext.experiments.v2GetGroup('smb_growth_boost_text') || ''}
          isEligible={eligibleForBoostExp(viewer, requestContext.language)}
          name={'smb_growth_boost_text'}
        >
          {children}
        </GenericExperiment>
      )}
    </RequestContextConsumer>
  );
}

export default withViewer(BoostTextExperiment);
